import React from 'react';
import styles from './Footer.module.css';
import { NavLink } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Menu', to: '/menu' },
  { label: 'Meet The Brews', to: '/brews' },
  { label: 'Life at Berli', to: '/gallery' },
  { label: 'Contact Us', to: '/contact' },
];

const SOCIALS = [
  {
    label: 'Follow us on Instagram',
    href: 'https://www.instagram.com/berlibrewingco/',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
      </svg>
    ),
  },
  {
    label: 'Follow us on Facebook',
    href: 'https://www.facebook.com/people/Berli-Brewing-Co/61590093867493/',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </svg>
    ),
  },
  {
    label: 'Follow us on LinkedIn',
    href: 'https://www.linkedin.com/company/berli-brewing-company',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
        <rect x="2" y="9" width="4" height="12" />
        <circle cx="4" cy="4" r="2" />
      </svg>
    ),
  },
];

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>

        {/* ── Info Row ── */}
        <div className={styles.infoRow}>

          <div className={styles.infoCol}>
            <h4 className={styles.label}>Address</h4>
            <p className={styles.address}>
              11th Floor, Gera Imperium Alpha,<br />
              Rajaram Patil Nagar, Vitthal Nagar,<br />
              Kharadi, Pune, Maharashtra 411014
            </p>
          </div>

          <div className={styles.infoCol}>
            <h4 className={styles.label}>Contact</h4>
            <p className={styles.value}>
              +91 74200 01640<br />
              contact@berlibrewing.com
            </p>
          </div>

          <div className={styles.infoCol}>
            <h4 className={styles.label}>Opening Hours</h4>
            {/* --- UPDATED TIMINGS HERE --- */}
            <p className={styles.value}>
              1:00 PM – 1:30 AM<br />
              Tue – Sun<br />
              <br />
              6:00 PM – 1:30 AM<br />
              Monday (Dinner only)
            </p>
          </div>

          <div className={styles.infoCol}>
            <h4 className={styles.label}>Follow Us</h4>
            <div className={styles.socials}>
              {SOCIALS.map(({ label, href, icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  aria-label={label}
                >
                  <span className={styles.socialIcon}>{icon}</span>
                </a>
              ))}
            </div>
          </div>

        </div>

        {/* ── Nav Row ── */}
        <nav className={styles.navRow}>
          {NAV_LINKS.map(({ label, to }, i) => (
            <React.Fragment key={label}>
              {i > 0 && <span className={styles.navDot} aria-hidden="true">·</span>}
              <NavLink to={to} className={styles.navLink}>{label}</NavLink>
            </React.Fragment>
          ))}
        </nav>

        {/* ── Bottom Bar ── */}
        <div className={styles.bottomBar}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} Berli Brewing Co. All rights reserved.
          </p>

          <p className={styles.attribution}>
            Berli Brewing Co. is a Brand owned by Tiny Rebel Brewing Pvt. Ltd.
          </p>

          <NavLink to="/privacy-policy" className={styles.privacyLink}>
            Privacy Policy
          </NavLink>
        </div>

      </div>
    </footer>
  );
};

export default Footer;